import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const ShipperGuide = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL(`https://shipperguide.com/` + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = `https://shipperguide.com/`;
    }
  }, [pathURL]);
  return <div />;
};

export default ShipperGuide;
